import type { ReactElement } from "react"
import { Fragment } from "react"

import { useTranslation } from "react-i18next"
import { useQuery } from "react-query"
import { useSelector } from "react-redux"

import { Skeleton, Typography } from "@synapse-analytics/synapse-ui"
import type { AxiosError, AxiosResponse } from "axios"

import { KonanLogo } from "../../../components/icons/KonanLogo"
import { KonanAPI } from "../../../services/KonanAPI"
import type { RootState } from "../../../store/ReduxStore"
import type { Model } from "../../../types/generated/api/Model"

export function TrainedByKonan(): ReactElement {
  const currentModel = useSelector((state: RootState) => state.models.currentModel)
  const { t } = useTranslation("models")

  const { data: model, isLoading } = useQuery<AxiosResponse<Model>, AxiosError>(
    ["model", currentModel?.uuid],
    () => KonanAPI.fetchModel(currentModel?.uuid as string),
    {
      enabled: !!currentModel?.uuid,
    },
  )

  const modelTrainedOrRetrained =
    model?.data.retraining_job !== null
      ? t("tags.retrained_by")
      : model?.data.automl_training_job
        ? t("tags.trained_by")
        : ""

  if (isLoading) return <Skeleton height={10} width="120px" />

  if (modelTrainedOrRetrained?.length > 0)
    return (
      <Typography variant="label-regular">
        {modelTrainedOrRetrained} <KonanLogo logoWidth={45} />
      </Typography>
    )

  return <Fragment />
}
